import React, { useMemo } from 'react'
import { GalleryProvider } from '../context/GalleryContext'
import GalleryPicker from './GalleryPicker'
import type { GalleryPickerProps } from './GalleryPicker'
import type { GalleryContextValue } from '../context/GalleryContext'

export interface GalleryPickerWithProviderProps extends GalleryPickerProps {
  orgId: string
  storeId?: string
  getFolderId: (folderId: string) => string
  isFileImage: (file: unknown) => boolean
  compressImage?: (file: File, options: Record<string, unknown>) => Promise<File>
}

export const GalleryPickerWithProvider: React.FC<GalleryPickerWithProviderProps> = ({
  orgId,
  storeId,
  getFolderId,
  isFileImage,
  compressImage,
  ...galleryProps
}) => {
  const contextValue = useMemo<GalleryContextValue>(
    () => ({
      orgId,
      storeId,
      getFolderId,
      isFileImage,
      compressImage,
    }),
    [orgId, storeId, getFolderId, isFileImage, compressImage],
  )

  return (
    <GalleryProvider value={contextValue}>
      <GalleryPicker {...galleryProps} />
    </GalleryProvider>
  )
}

export default GalleryPickerWithProvider
